function fn_comp_product_detail() {

    var $slider = $(".product-slides"),
        $prevArrow = $slider.closest(".mod--row").find(".col-arrow").find(".arrs").find(".slick-previous"),
        $nextArrow = $slider.closest(".mod--row").find(".col-arrow").find(".arrs").find(".slick-next");

	if ($(window).width() < 1024) {
	   $('.product-slides').slick({
		autoplay: true,
		slidesToShow: 2,
		slidesToScroll: 2,
		autoplaySpeed: 5000,
        arrows: true,
		nextArrow: $nextArrow,
        prevArrow: $prevArrow
	});
	}
	else {
	   $('.product-slides').slick({
		autoplay: true,
		slidesToShow: 4,
		slidesToScroll: 4,
		autoplaySpeed: 5000,
        arrows: true,
        nextArrow: $nextArrow,
        prevArrow: $prevArrow
	});
	}
}